import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PickupOperatorCreateEditForm from './Components/PickupOperatorCreateEditForm';
import PickupOperatorApi from './PickupOperatorApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PickupOperatorCreateEditForm,
                getCreate: PickupOperatorApi.create,
                defaults: {},
                successMessage: "PickupOperator Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}